import React, { useContext, useState, useEffect } from 'react'
import { Paper, Typography, Button } from '@mui/material'
import { AuthContext } from '../context/AuthContext'
import Loading from '../component/commonUnit/Loading'
import SessionTable from '../component/session/SessionTable'
import UserProfileSession from '../component/topBar/UserProfileSession'
import { useNavigate } from 'react-router-dom'
import { getSessionsByCreatorId, getSessionsByCRN, getSessionsByUserId } from '../service/sessionService'

const Session = () => {
  const { currentUser } = useContext(AuthContext)
  const [crn, setCrn] = useState('')
  const [sessions, setSessions] = useState([])

  const navigate = useNavigate()
  const handleHomePage = () => {
    navigate('/about')
  }
 

  useEffect(() => {
    if (!currentUser) return
  
    // Decide how you want to fetch:
    const fetchSessions = async () => {
      let sessionsData = []
  
      // If user is instructor/admin (assuming role <= 1)
      if (currentUser.role <= 1) {
        console.log("getting teachers")
        sessionsData = await getSessionsByCreatorId(currentUser.id)
        setSessions(sessionsData)
        console.log(sessions)
      }
      // Else if user is a student with CRN
      else if (currentUser.crn) {
        sessionsData = await getSessionsByCRN(currentUser.crn)
        setSessions(sessionsData)
      }
  
      
    }
  
    fetchSessions()
  }, [currentUser])
  
  useEffect(() => {
    console.log('Sessions updated:', sessions);
  }, [sessions]);
  

  if (!currentUser) return <Loading />

  return (
    <div className="session">
      <Paper elevation={3} className="session-form">
        <div className="session-header">
          <div className="session-menu">
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                display: 'block',
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'white',
                textDecoration: 'none',
                margin: '0.5em',
              }}>
              VizPI
            </Typography>
            <Button
              onClick={handleHomePage}
              sx={{ my: 2, color: 'white', display: 'block' }}>
              Homepage
            </Button>
          </div>
          <UserProfileSession />
        </div>
        <SessionTable sessions={sessions} />
      </Paper>
    </div>
  )
}

export default Session
